import { useState, useEffect, useCallback } from 'react'

const DEFAULT_COOLDOWN_SECONDS = 30

export function useCooldownTimer(seconds = DEFAULT_COOLDOWN_SECONDS) {
  const [cooldownSeconds, setCooldownSeconds] = useState(0)

  useEffect(() => {
    if (cooldownSeconds <= 0) return

    const timer = setInterval(() => {
      setCooldownSeconds((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [cooldownSeconds])

  const startCooldown = useCallback(() => {
    setCooldownSeconds(seconds)
  }, [seconds])

  return {
    cooldownSeconds,
    startCooldown,
    isOnCooldown: cooldownSeconds > 0,
  }
}
